import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { whyChooseUs } from '../data/mock';

const WhyUs = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#8B0000]/10 text-[#8B0000] border-[#8B0000]/20">
            Keunggulan Kami
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Mengapa Memilih <span className="text-[#8B0000]">Marhaban Tour?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Komitmen kami adalah memberikan pengalaman ibadah yang tak terlupakan
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {whyChooseUs.map((item, index) => {
            const Icon = LucideIcons[item.icon];
            return (
              <Card 
                key={index}
                className="group relative overflow-hidden border-2 border-gray-100 hover:border-[#8B0000] transition-all duration-300 hover:shadow-xl"
              >
                {/* Background Decoration */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#8B0000]/5 rounded-full blur-2xl group-hover:bg-[#F5C842]/10 transition-all duration-500"></div>
                
                <CardContent className="p-8 relative z-10">
                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#8B0000]/10 to-[#F5C842]/10 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-[#8B0000]" strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#8B0000] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Trust Badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-6">
          <div className="flex items-center space-x-3 px-6 py-3 bg-white rounded-full shadow-md border border-gray-100">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-700">Terdaftar Resmi Kemenag RI</span>
          </div>
          <div className="flex items-center space-x-3 px-6 py-3 bg-white rounded-full shadow-md border border-gray-100">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-700">Izin Operasional Lengkap</span>
          </div>
          <div className="flex items-center space-x-3 px-6 py-3 bg-white rounded-full shadow-md border border-gray-100">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-700">Garansi Keberangkatan 100%</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
